






























































































































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {
    ChatTemplate
} from '@/entities/chat'
import {addTemplate, deleteTemplate, saveTemplate} from '@/api/chat'
import VueSlideUpDown from 'vue-slide-up-down'

declare const UIkit

@Component<ChatEditTemplate>({
    components: {VueSlideUpDown}
})
export default class ChatEditTemplate extends Vue {

    @Prop(Number) public questionId !: number
    @Prop({type: Object}) public template !: ChatTemplate
    @Prop(Array) public fields !: string[]
    @Prop(Number) public isFiveScore !: number
    @Prop(Function) public onTemplateUpdate // when action is done
    @Prop(Object) public customData!: { watching }

    public id: number = this.template && Number(this.template.id) || 0
    public name: string = this.template && this.template.name || ''
    public subject: string = this.template && this.template.raw_subject || ''
    public text: string = this.template && this.template.raw_text || ''
    public permanent = this.template ? Number(this.template.permanent || 0) : 0
    public calendly_link: string = this.template && this.template.calendly && this.template.calendly.link || ''
    public calendly_text: string = this.template && this.template.calendly && this.template.calendly.text || ''
    public fieldCategory = ''

    public get htmlFields() {
        return '<code class="field">&#123;'
            + this.fields.join('&#125;</code> <code class="field">&#123;')
            + '&#125;</code>'
    }

    public onSelectFieldCategory(item) {
        if (item === this.fieldCategory) {
            this.fieldCategory = ''
        } else {
            this.fieldCategory = item
        }
    }

    public onCancel() {
        this.onTemplateUpdate(0)
    }

    public async onSave() {
        let ret
        // save template
        if (this.id) {
            ret = await saveTemplate(this.questionId, {
                name: this.name,
                subject: this.subject,
                text: this.text,
                id: this.id,
                calendly: {
                    link: this.calendly_link,
                    text: this.calendly_text
                }
            })
        } else {
            ret = await addTemplate(this.questionId, {
                name: this.name,
                subject: this.subject,
                text: this.text,
                id: this.id,
                calendly: {
                    link: this.calendly_link,
                    text: this.calendly_text
                }
            })
        }
        if (ret.data.success) {
            this.onTemplateUpdate(1)
        } else {
            UIkit.notify(ret.data.message, 'danger')
            return false
        }
    }

    public async onDelete() {
        if (confirm('Are you sure to delete the template?')) {
            // delete template first
            await deleteTemplate(this.questionId, this.id)
            this.onTemplateUpdate(1)
        }
    }
}
